import style from "./00_tcp.css"
import Header from '../components/header'
import Footer from '../components/footer'

export default function HITStudent() {
    return (
    <div style={{ backgroundColor: "#FFFDF4", minHeight: "100vh" }}>
        <Header />
            <div class="legal-document">
<h1>How It Works — Students</h1>

<p>Finding a music teacher through SurSaathi is simple. We help you discover teachers and facilitate the initial connection so you can decide whether a teacher is right for you.</p>

<h2>1. Find a Teacher</h2>

<p>You can browse music teacher listings on SurSaathi and look for teachers based on factors such as:</p>

<ul>
  <li>Instrument or subject taught</li>
  <li>Teaching experience</li>
  <li>Qualifications or professional information</li>
  <li>General location</li>
  <li>Availability</li>
  <li>Profile information</li>
</ul>

<p>Teacher information is generally provided by the teachers themselves. A listing on SurSaathi does not mean that we have certified or endorsed the teacher.</p>

<h2>2. Request Information or Get in Touch</h2>

<p>If you are interested in a particular teacher, you may submit a request through SurSaathi.</p>

<p>Depending on the circumstances, we may share relevant information from your request with the teacher so that the teacher can contact you. We may also provide you with relevant information about the teacher.</p>

<p>The purpose of this process is to help you and the teacher communicate directly.</p>

<h2>3. What Information May Be Shared?</h2>

<p>To facilitate the connection, we may share relevant information such as:</p>

<ul>
  <li>Your name</li>
  <li>Contact details</li>
  <li>General location</li>
  <li>Instrument or subject you are interested in</li>
  <li>Your requirements or preferences</li>
  <li>Other information relevant to your request</li>
</ul>

<p>Please do not provide unnecessary sensitive information through our forms.</p>

<p>Once your contact details have been shared, the teacher may be able to contact you directly. You should therefore only provide information that you are comfortable sharing for the purpose of finding a teacher.</p>

<h2>4. What Happens After You Connect?</h2>

<p>Once you and the teacher are able to communicate directly, you and the teacher decide the details of the teaching arrangement.</p>

<p>You should discuss and agree on matters such as:</p>

<ul>
  <li>Lesson fees</li>
  <li>Payment method</li>
  <li>Frequency of lessons</li>
  <li>Lesson duration</li>
  <li>Online or in-person lessons</li>
  <li>Lesson location</li>
  <li>Trial lessons</li>
  <li>Cancellation and rescheduling</li>
  <li>Transportation arrangements</li>
  <li>Instruments or equipment</li>
  <li>Practice requirements</li>
  <li>Refund arrangements</li>
  <li>Any other terms that are important to you</li>
</ul>

<p>SurSaathi does not set lesson fees, collect lesson fees, arrange lessons, or become a party to the agreement between you and the teacher unless we expressly state otherwise.</p>

<h2>5. How Much Does It Cost?</h2>

<p>SurSaathi may facilitate the discovery and initial contact between students and teachers.</p>

<p>Unless a particular SurSaathi service expressly states otherwise, <strong>we do not charge you a lesson fee or take part in the payment arrangement between you and your teacher.</strong></p>

<p>Any fees for music lessons are agreed directly between you and the teacher.</p>

<h2>6. How Do I Know If a Teacher Is Good?</h2>

<p>A teacher's presence on SurSaathi does not guarantee their qualifications, teaching ability, identity, experience, availability, conduct, or suitability.</p>

<p>You should independently evaluate the teacher before deciding to take lessons.</p>

<p>You may wish to:</p>

<ul>
  <li>Ask about their teaching experience and qualifications.</li>
  <li>Ask about their teaching methods.</li>
  <li>Discuss fees and lesson arrangements before starting.</li>
  <li>Verify information that is important to you.</li>
  <li>Consider a trial lesson where appropriate.</li>
  <li>Choose an appropriate and safe location for in-person lessons.</li>
</ul>

<h2>7. Safety First</h2>

<p>Please use reasonable care when communicating with or meeting someone you found through SurSaathi.</p>

<p>In particular:</p>

<ul>
  <li>Do not share passwords, OTPs, banking credentials, government identification documents, or other sensitive information.</li>
  <li>Consider having a parent, guardian, or trusted adult involved in initial communications.</li>
  <li>For an initial in-person meeting, consider choosing a safe and appropriate location.</li>
  <li>Tell a family member or trusted person about the meeting.</li>
  <li>Avoid meeting an unfamiliar person alone in an isolated location.</li>
  <li>Do not agree to unsafe transportation arrangements.</li>
  <li>If something feels wrong or unsafe, discontinue communication and seek appropriate assistance.</li>
</ul>

<p>SurSaathi cannot guarantee how another user will behave after contact information has been shared.</p>

<h2>8. If the Student Is Under 18</h2>

<p>If the student is a minor, a <strong>parent or legal guardian should take primary responsibility for evaluating and supervising the teacher–student arrangement.</strong></p>

<p>Parents or guardians should consider:</p>

<ul>
  <li>Reviewing the teacher's information.</li>
  <li>Verifying relevant identity and qualification information.</li>
  <li>Communicating with the teacher where appropriate.</li>
  <li>Discussing fees and lesson arrangements.</li>
  <li>Knowing when and where lessons will take place.</li>
  <li>Considering being present during in-person lessons.</li>
  <li>Ensuring transportation arrangements are safe.</li>
  <li>Monitoring communications where appropriate.</li>
</ul>

<p>SurSaathi does not act as a parent, guardian, chaperone, childcare provider, or supervisor.</p>

<h2>9. What Is SurSaathi Responsible For?</h2>

<p>Our role is primarily to help you discover teachers and facilitate initial communication.</p>

<p>We do not guarantee:</p>

<ul>
  <li>The teacher's qualifications or skill</li>
  <li>The quality or outcome of lessons</li>
  <li>The teacher's identity</li>
  <li>The teacher's availability</li>
  <li>The teacher's conduct</li>
  <li>The safety of meetings or lessons</li>
  <li>Payment or refunds</li>
  <li>Attendance or punctuality</li>
  <li>The suitability of a teacher for your particular needs</li>
</ul>

<p>Once you and the teacher connect, you are responsible for deciding whether and how to proceed.</p>

<h2>10. Have a Concern?</h2>

<p>If you encounter suspicious, abusive, threatening, fraudulent, or inappropriate behaviour involving a teacher listing or the SurSaathi platform, you can contact us.</p>

<p>Where appropriate, we may review a report and may remove a listing, restrict access, suspend a user, or take other reasonable action.</p>

<p>For an immediate threat to life or physical safety, contact the appropriate emergency or law-enforcement authority rather than relying solely on SurSaathi.</p>

<p><strong>SurSaathi helps you find and connect with music teachers. You remain responsible for independently evaluating the teacher and making safe and informed decisions about any teaching arrangement.</strong></p>
            </div>
        <Footer />
    </div>
  );
}